export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}
